export default "__VITE_ASSET__Cdft0KG2__"